import { addError } from './error';
import api from '../../helpers/ApiClient';

export const REQUEST_ORDER_SUMMARY = 'REQUEST_ORDER_SUMMARY';
export const RECEIVE_ORDER_SUMMARY = 'RECEIVE_ORDER_SUMMARY';
export const FAIL_ORDER_SUMMARY = 'FAIL_ORDER_SUMMARY';
export const CLEAR_ORDER_SUMMARY = 'CLEAR_ORDER_SUMMARY';
export const CLEAR_MISSING_ITEMS_WARNING = 'CLEAR_MISSING_ITEMS_WARNING';
export const MISSING_ITEMS_WARNING = 'MISSING_ITEMS_WARNING';

function receiveOrderSummary(json, items) { 
  return {
    type: RECEIVE_ORDER_SUMMARY,
    payload: {
      detail: json,
      items,
      receivedAt: Date.now(),
    }
  };
}

function requestOrderSummary(items) {
  return {
    type: REQUEST_ORDER_SUMMARY,
    payload: {
      items,
    }
  };
}

function failOrderSummary(items) {
  return {
    type: FAIL_ORDER_SUMMARY,
    payload: {
      items,
    }
  };
}

export function missingItemsWarning(missingItems) {
  return {
    type: MISSING_ITEMS_WARNING,
    payload: {
      missingItems,
    }
  };
}

function shouldFetchOrderSummary(state, items) {
  if (!items || !items.length) {
    return false;
  }
  const results = state.orderSummary;
  if (results && results.loading) {
    return false;
  } else {
    return true;
  }
}

function fetchOrderSummaryFromApi(items) {
  return dispatch => {
    // const newItems = items.concat({
    //   "article_number": "1791.111.42",
    //   "name": "test",
    //   "color": "white",
    //   "quantity": "1"
    // });
    // let postItems = newItems.map(item => {
    //   return {
    //     article_number: item.article_number,
    //     quantity: item.quantity
    //   }
    // });
    let postItems = items.map(item => {
      return {
        article_number: item.article_number,
        quantity: item.quantity
      }
    });
    dispatch(requestOrderSummary(postItems));
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postItems)
    }
    return api(`/ikea/ikea/json`, options)
      .then(json => {
        dispatch(receiveOrderSummary(json, postItems))
        if (json.missing_articles && json.missing_articles.length) {
          const missingItems = items.filter(item =>{
            return json.missing_articles.indexOf(item.article_number) !== -1;
          });
          dispatch(missingItemsWarning(missingItems));
        }
      })
      .catch(err => {
        dispatch(failOrderSummary(postItems));
        dispatch(addError(err));
      });
  };
}

export function fetchOrderSummary(items) {
  return (dispatch, getState) => {
    if (shouldFetchOrderSummary(getState(), items)) {
      return dispatch(fetchOrderSummaryFromApi(items));
    }
  };
}

export function clearOrderSummary() {
  return {
    type: CLEAR_ORDER_SUMMARY,
  };
}

export function clearMissingItemsWarning() {
  return {
    type: CLEAR_MISSING_ITEMS_WARNING,
  };
}